<section class="workflow-list-container" *ngIf="(steps$|async)?.length">
    <ng-container>
        <gen-workflow-step *ngFor="let item of steps$|async;let i = index; trackBy:trackByFn"
                           [revision]="revision"
                           [stepTaglineField]="stepTagline"
                           [testElapsedTime]="testElapsedTime"
                           [stepItem]="item"
                           [activeIndex]="activeIndex"
                           [currentIndex]="i"></gen-workflow-step>
    </ng-container>
</section>
<section class="steps Flexbox workflow-items" *ngIf="!(steps$|async)?.length">
    <div style="display: flex;width:100%;">
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="isAllowedStep('beforeReview')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip
                  [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="isAllowedStep('beforeReview') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column" *ngIf="showSteps"
             [ngClass]="{'active': isActiveStep('reviewtestresults')}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom">{{showCancelledStatus('reviewtestresults') ? currentRevision.status : 'Review'}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="isAllowedStep('reviewtestresults')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="isAllowedStep('reviewtestresults') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column" *ngIf="hasSecondOpinion"
             [ngClass]="{'active': isActiveStep('2ndopinionrequested')}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" *ngIf="!showCancelledStatus('2ndopinionrequested')">2<sup>nd</sup> opinion requested</span>
            <span class="bottom" *ngIf="showCancelledStatus('2ndopinionrequested')">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="hasSecondOpinion && isAllowedStep('2ndopinionrequested')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="hasSecondOpinion && isAllowedStep('2ndopinionrequested') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column" *ngIf="hasSecondOpinion"
             [ngClass]="{'active': isActiveStep('2ndopinionreview')}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" *ngIf="!showCancelledStatus('2ndopinionreview')">2<sup>nd</sup> opinion review</span>
            <span class="bottom" *ngIf="showCancelledStatus('2ndopinionreview')">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="isAllowedStep('2ndopinionreview')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="isAllowedStep('2ndopinionreview') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column" *ngIf="showSteps"
             [ngClass]="{'active': isActiveStep('initialresults')}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom">{{showCancelledStatus('initialresults,therapymatch,clinicalTrialMatch') ? currentRevision.status : 'Initial results'}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="isAllowedStep('betweenInitialAndFinalResults')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="isAllowedStep('betweenInitialAndFinalResults') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column" *ngIf="showSteps"
             [ngClass]="{'active': isActiveStep('interpretationresults')}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom">{{getStatus('interpretationresults')}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="isAllowedStep('interpretationresults')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="isAllowedStep('interpretationresults') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column"
             *ngIf="showSteps && stepInItems('finalreview')"
             [ngClass]="{'active': isActiveStep('final review')}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom">{{showCancelledStatus('final review') ? currentRevision.status : 'Final review'}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column active"
             *ngIf="isAllowedStep('final review')">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom" genTooltip [tooltipPosition]="'BOTTOM'"
                  [tooltipText]="currentRevision.humanReadableMessage"
                  [tooltipShow]="isAllowedStep('interpretationresults') && currentRevision.humanReadableMessage">{{currentRevision.status}}</span>
        </div>
        <div class="step Flexbox Flexbox__flex-1 Flexbox__box-direction-column" *ngIf="showSteps"
             [ngClass]="{'active': (isActiveStep('testCompleted') && !isAllowedStep('beforeReview'))}">
            <div class="top Flexbox">
                <span class="leftBorder"></span>
                <div class="content Flexbox">
                    <span class="point"></span>
                </div>
                <span class="rightBorder"></span>
            </div>
            <span class="bottom">{{showCancelledStatus('testCompleted') ? currentRevision.status : 'Test Completed'}}</span>
        </div>
    </div>
</section>